<template>
  <div class="new_fiat">
      <div class="steps_box">
        <!-- 步骤条 -->
        <div class="step1">
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/dui_icon.png" alt="">
                    <img class="s_img2" src="../../../assets/img/xian1.png" alt="">
                </div>
                <div class="div1">{{$t('main.text389')}}</div>
            </div>
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/num2.png" alt="">
                    <img class="s_img2" src="../../../assets/img/xian2.png" alt="">
                </div>
                <div class="div1">{{$t('main.text365')}}</div>
            </div>
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/num3.png" alt="">
                </div>
                <div class="div1">{{$t('main.text390')}}</div>
            </div>
        </div>
        <!-- ----- -->

        <div class="zdy_table_list">
            <div class="table_btm">
                <div class="table_btm_t1">{{$t('main.text391')}}</div>
                <el-button class="add_btn border_set_color" icon="el-icon-plus" @click="add_btn">{{$t('main.text377')}}</el-button>
            </div>
            <div class="table_btm2">
                <div class="list_title1">{{$t('main.text404')}}</div>
                <table class="list_table">
                    <div v-for="(item,index) in tableData" :key="index">
                        <div class="td1">
                            <el-checkbox-group v-model="checkList" @change="checkbox_fun(item)">
                                <el-checkbox :label="item.beneficiary_name">{{item.beneficiary_name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="td2">{{item.name}}</div>
                        <div class="td3">{{item.account_number}}</div>
                        <div>
                            <el-popover
                                placement="bottom-end"
                                popper-class="operate_pop"
                                width="100"
                                trigger="hover">
                                <img slot="reference" class="sand_img" src="../../../assets/img/sand.png" alt="">
                                <div>
                                    <div class="edit_btn" @click="edit_fun(item)">{{$t('main.text71')}}</div>
                                    <div class="delete_btn" @click="delete_fun(item)">{{$t('main.text363')}}</div>
                                </div>
                            </el-popover>
                        </div>
                    </div>
                    <span v-if="page_total<=0" class="no_data_text">{{$t('main.text364')}}</span>
                </table>
                <el-pagination
                v-if="tableData.length > 0"
                background
                :page-sizes="[10, 20, 30, 40]"
                :page-size="limit"
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :total="page_total"
                @current-change="current_change"
                ></el-pagination>
            </div>
        </div>

        <div v-if="select_box_show">
            <!-- 竖线 -->
            <img class="shuxian" src="../../../assets/img/shuxian.png" alt="">
        </div>

        <div class="zdy_table_list" v-if="select_box_show">
            <!-- 第三行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1">{{$t('main.text405')}}</div>
                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text360')">
                                <el-select v-model="purpose" :placeholder="$t('main.text135')">
                                    <el-option
                                        v-for="(item,index) in transaction_list"
                                        :key="index"
                                        :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text406')">
                                <el-input v-model="email"></el-input>
                                <!-- <div class="inp_btm_txt">We will send the transfer update to this email</div> -->
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item class="width_auto">
                                <div class="continue_btn" @click="select_edit_fun">{{$t('main.text394')}}</div>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                </el-form>
            </div>
        </div>

        <div v-if="addr_box_show">
            <!-- 竖线 -->
            <img class="shuxian" src="../../../assets/img/shuxian.png" alt="">
        </div>

        <div class="zdy_table_list" v-if="addr_box_show">
            <!-- 第一行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1">{{$t('main.text351')}}</div>
                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text352')">
                                <el-input v-model="add_form.name"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text280')">
                                <el-input v-model="add_form.account_number"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text348')">
                                <el-input v-model="add_form.beneficiary_name"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text353')">
                                <el-input v-model="add_form.swift_code"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text277')">
                                <el-input v-model="add_form.address"></el-input>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                    
                </el-form>

            </div>
            <!-- 第二行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1">{{$t('main.text354')}}</div>
                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text355')">
                                <el-input v-model="add_form.intermediary_name"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text356')">
                                <el-select filterable v-model="add_form.intermediary_country" :placeholder="$t('main.text135')">
                                    <!-- <el-option
                                        v-for="item in code_json"
                                        :key="item"
                                        :label="item"
                                        :value="findKey(code_json, item)">
                                    </el-option> -->

                                    <!-- <el-option
                                        v-for="item in code_json"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option> -->

                                    <div v-for="(item,name) in code_json" :key="name">
                                        <el-option
                                            v-for="(item,index) in item" :key="index"
                                            :label="item.name"
                                            :value="item.name">
                                        </el-option>
                                    </div>

                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text357')">
                                <el-input v-model="add_form.intermediary_swift_code"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text358')">
                                <el-input v-model="add_form.intermediary_address"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="d_row" v-if="add_or_edit">
                        <div>
                            <el-form-item class="width_auto">
                                <div class="sc_ntb border_set_color" @click="xingx_fun">
                                    <img v-if="xingx" class="xingx_img" src="../../../assets/img/xingx_yes.png" alt="">
                                    <img v-else class="xingx_img" src="../../../assets/img/xingx_no.png" alt="">
                                    {{$t('main.text393')}}
                                </div>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                    
                </el-form>

            </div>

            <!-- 第三行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1" v-if="add_or_edit">{{$t('main.text405')}}</div>
                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row" v-if="add_or_edit">
                        <div>
                            <el-form-item :label="$t('main.text360')">
                                <el-select v-model="purpose" :placeholder="$t('main.text135')">
                                    <el-option
                                     v-for="(item,index) in transaction_list"
                                     :key="index"
                                     :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text406')">
                                <el-input v-model="email"></el-input>
                                <!-- <div class="inp_btm_txt">We will send the transfer update to this email</div> -->
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item class="width_auto">
                                <div v-if="add_or_edit" class="continue_btn" @click="add_form_btn">{{$t('main.text394')}}</div>
                                <div v-else class="continue_btn" @click="add_form_btn">{{$t('main.text395')}}</div>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                    
                </el-form>

            </div>
        </div>
      
      </div>

      <!-- 删除 -->
    <el-dialog
        :visible.sync="delete_user_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text367')}}
        </div>
        <div class="log_out3">
          {{$t('main.text379')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="delete_user_dlg = false" class="cancel_btn border_set_color2">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="del_dlg_remove">{{$t('main.text369')}}</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
// import {withdraw_payee_list,withdraw_payee_add,withdraw_payee_edit,withdraw_payee_del} from '@/api/api';
import {withdraw_payee_list,withdraw_payee_edit,withdraw_payee_del} from '@/api/api';
import * as EmailValidator from 'email-validator';
export default {
    data() {
        return {
            checkList: [],
            select_v:'',
            xingx:false,
            delete_user_dlg:false,

            f_api_data:{
                details:{}
            },
            currentPage: 1,//选中的页数
            page: 1, //分页 从 1 开始
            limit: 10, //每页条数
            page_total: 0, //一共多少条
            tableData:[],
            addr_box_show:false,
            select_box_show:false,
            add_form:{
                name:"",
                account_number:"",
                beneficiary_name:"",
                swift_code:"",
                address:"",

                intermediary_name:"",
                intermediary_country:"",
                intermediary_swift_code:"",
                intermediary_address:""
            },
            purpose:'',
            email:'',

            transaction_list:[
                this.$t('main.text407'),
                this.$t('main.text408'),
                this.$t('main.text409'),
                this.$t('main.text410'),
                this.$t('main.text411'),
                this.$t('main.text412'),
                this.$t('main.text413'),
                this.$t('main.text414'),
                this.$t('main.text415'),
                this.$t('main.text416'),
                this.$t('main.text417'),
                this.$t('main.text418'),
                this.$t('main.text419'),
                this.$t('main.text420'),
                this.$t('main.text421'),
                this.$t('main.text422'),
                this.$t('main.text423'),
                this.$t('main.text424'),
                this.$t('main.text425'),
                this.$t('main.text426'),
                this.$t('main.text427'),
                this.$t('main.text428'),
                this.$t('main.text429'),
                this.$t('main.text430'),
                this.$t('main.text431'),
                this.$t('main.text432'),
                this.$t('main.text433'),
                this.$t('main.text434'),
                this.$t('main.text435'),
                this.$t('main.text436'),
                this.$t('main.text437'),
                this.$t('main.text438'),
                this.$t('main.text439'),
                this.$t('main.text440'),
                this.$t('main.text441'),
                this.$t('main.text442'),
                this.$t('main.text443'),
                this.$t('main.text444'),
                this.$t('main.text445'),
                this.$t('main.text446'),
                this.$t('main.text447'),
                this.$t('main.text448'),
                this.$t('main.text449'),
                this.$t('main.text450'),
                this.$t('main.text451')
            ],
            add_or_edit:true,//true 默认添加  false 编辑
            del_item:{},
            select_act_item:{},
            xingx_btm_tit:true,

            FirstPin: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
            code_json:{},

        }
    },
    created() {
        // this.code_json=require("@/assets/phone_code/num_area_en.json");
        // 引入国家码 中英
        if (this.v_lan=='ch') {
            // this.code_json=require("@/assets/phone_code/num_area_ch2.json");
            this.code_json=require("@/assets/phone_code/num_area_ch2.json");
        }else{
            this.code_json=require("@/assets/phone_code/num_area_en2.json");
        }

        if (this.code_json) {
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
                cityName[item] = [];
                this.code_json.forEach(el => {
                    //对比开头字母是否对应
                    // 做一个判断 中文时候不走
                    let first = el.py.substring(0, 1).toUpperCase();
                    if (first == item) {
                        cityName[item].push(el);
                    }
                });            
            });
            // console.log(cityName)
            this.$nextTick(()=>{
                this.code_json = cityName;
                // console.log(this.code_json);
            })
        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',this.$t('main.text452'));
        this.f_api_data = JSON.parse(sessionStorage.getItem("fb_bz_1"));
        // console.log(this.f_api_data);
        this.get_list();
    },
    methods: {
        //创建一个方法，返回value值对应的key
        findKey(obj, value, compare = (a, b) => a === b) {
            return Object.keys(obj).find((k) => compare(obj[k], value));
        },
        current_change(v){
            // console.log(v);
            this.page=v;
            this.limit=10;
            this.get_list();
        },
        checkbox_fun(item){
            this.addr_box_show=false;
            this.checkList=[];
            this.checkList=[item.beneficiary_name];
            
            this.purpose='';
            this.email='';
            this.select_box_show=true;
            this.select_act_item=item;

            // 星星 是否收藏
            sessionStorage.setItem("fa_xingx",false);

            // 滚动到页面底部
            setTimeout(() => {
                this.bus.$emit('scroll_set');
            }, 100);
        },
        get_list(){
            withdraw_payee_list({
                page:this.page,
                limit:this.limit,
            }).then(res=>{
                if (res.data.code==200) {
                    this.tableData=res.data.data.list;
                    this.page_total=res.data.data.count;
                    // console.log(res.data.data.list);
                }
            })
        },
        add_btn(){
            this.select_box_show=false;
            
            this.checkList=[];
            this.add_form.name="";
            this.add_form.account_number="";
            this.add_form.beneficiary_name="";
            this.add_form.swift_code="";
            this.add_form.address="";

            this.add_form.intermediary_name="";
            this.add_form.intermediary_country="";
            this.add_form.intermediary_swift_code="";
            this.add_form.intermediary_address="";

            this.purpose='';
            this.email='';

            this.addr_box_show=true;
            this.add_or_edit=true;
            this.xingx_btm_tit=true;
            this.page=1;
            this.limit=10;
            this.currentPage=1;
            this.get_list();
            // 滚动到固定位置
            setTimeout(() => {
                if (this.page_total<=0) {
                    this.bus.$emit('scroll_set_num',123);
                }else{
                    this.bus.$emit('scroll_set_num',this.page_total * 67 + 590);
                }
            }, 100);
            
        },
        add_form_btn(){
            if (!this.add_form.name) {
                return this.message.ismessage('error',this.$t('main.text371'));
            }
            if (!this.add_form.account_number) {
                return this.message.ismessage('error',this.$t('main.text381'));
            }
            if (!this.add_form.beneficiary_name) {
                return this.message.ismessage('error',this.$t('main.text382'));
            }
            if (!this.add_form.swift_code) {
                return this.message.ismessage('error',this.$t('main.text383'));
            }
            if (!this.add_form.address) {
                return this.message.ismessage('error',this.$t('main.text384'));
            }
            // if (!this.add_form.intermediary_name) {
            //     return this.message.ismessage('error',this.$t('main.text385'));
            // }
            // if (!this.add_form.intermediary_country) {
            //     return this.message.ismessage('error',this.$t('main.text386'));
            // }
            // if (!this.add_form.intermediary_swift_code) {
            //     return this.message.ismessage('error',this.$t('main.text387'));
            // }
            // if (!this.add_form.intermediary_address) {
            //     return this.message.ismessage('error',this.$t('main.text388'));
            // }

            // 邮箱格式
            if (this.email && !EmailValidator.validate(this.email)) {
                return this.message.ismessage('error',this.$t('main.text453'));
            }
            
            

            if (this.add_or_edit) {
                if (this.xingx_btm_tit) {
                    if (!this.purpose) {
                        return this.message.ismessage('error',this.$t('main.text454'));
                    }
                }

                this.f_api_data.details=this.add_form;
                this.f_api_data.purpose=this.purpose;
                this.f_api_data.email=this.email;
                // 星星 是否收藏
                sessionStorage.setItem("fa_xingx",this.xingx);
                sessionStorage.setItem("fb_bz_1",JSON.stringify(this.f_api_data));
                this.$router.push('/blockchain_w/new_fiat2');
                // console.log(this.f_api_data);

                // 判断有没有星号 
                // if (this.xingx) {
                //     withdraw_payee_add({
                //         name:this.add_form.name,
                //         address:this.add_form.address,
                //         account_number:this.add_form.account_number,
                //         beneficiary_name:this.add_form.beneficiary_name,
                //         swift_code:this.add_form.swift_code,
                //         intermediary_name:this.add_form.intermediary_name,
                //         intermediary_address:this.add_form.intermediary_address,
                //         intermediary_country:this.add_form.intermediary_country,
                //         intermediary_swift_code:this.add_form.intermediary_swift_code
                //     }).then(res=>{
                //         if (res.data.code==200) {
                //             this.f_api_data.details=this.add_form;
                //             this.f_api_data.purpose=this.purpose;
                //             this.f_api_data.email=this.email;
                            
                //             sessionStorage.setItem("fb_bz_1",JSON.stringify(this.f_api_data));
                //             this.$router.push('/blockchain_w/new_fiat2');
                //             // console.log(this.f_api_data);
                //         }else{
                //             this.message.ismessage('error',res.data.msg);
                //         }
                //     })
                // }else{
                //     // next
                //     this.f_api_data.details=this.add_form;
                //     this.f_api_data.purpose=this.purpose;
                //     this.f_api_data.email=this.email;
                    
                //     sessionStorage.setItem("fb_bz_1",JSON.stringify(this.f_api_data));
                //     this.$router.push('/blockchain_w/new_fiat2');
                //     // console.log(this.f_api_data);
                // }

            }else{
                // 编辑
                withdraw_payee_edit({
                    id:this.add_form.id,
                    name:this.add_form.name,
                    address:this.add_form.address,
                    account_number:this.add_form.account_number,
                    beneficiary_name:this.add_form.beneficiary_name,
                    swift_code:this.add_form.swift_code,
                    intermediary_name:this.add_form.intermediary_name,
                    intermediary_address:this.add_form.intermediary_address,
                    intermediary_country:this.add_form.intermediary_country,
                    intermediary_swift_code:this.add_form.intermediary_swift_code,
                }).then(res=>{
                    if (res.data.code==200) {
                        this.page=1;
                        this.limit=10;
                        this.currentPage=1;
                        this.get_list();
                        this.addr_box_show=false;
                        this.message.ismessage('success',this.$t('main.text375'));
                    }else{
                        this.message.ismessage('error',res.data.msg);
                    }
                })
            }

        },
        edit_fun(item){
            this.add_or_edit=false;
            this.select_box_show=false;
            this.add_form=item;

            this.addr_box_show=true;
            // 滚动到固定位置
            setTimeout(() => {
                if (this.page_total<=0) {
                    this.bus.$emit('scroll_set_num',123);
                }else{
                    this.bus.$emit('scroll_set_num',this.page_total * 67 + 590);
                }
            }, 100);
        },
        delete_fun(item){
            this.del_item=item;
            this.delete_user_dlg=true;
        },
        del_dlg_remove(){
            withdraw_payee_del({
                id:this.del_item.id
            }).then(res=>{
                if (res.data.code==200) {
                    this.page=1;
                    this.limit=10;
                    this.currentPage=1;
                    this.get_list();
                    this.addr_box_show=false;
                    this.message.ismessage('success',this.$t('main.text376'));
                    this.delete_user_dlg=false;
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })
        },
        select_edit_fun(){
            if (!this.purpose) {
                return this.message.ismessage('error',this.$t('main.text454'));
            }
            // 邮箱格式
            if (this.email && !EmailValidator.validate(this.email)) {
                return this.message.ismessage('error',this.$t('main.text453'));
            }
            this.f_api_data.purpose=this.purpose;
            this.f_api_data.email=this.email;
            this.f_api_data.details={};

            this.f_api_data.details.name=this.select_act_item.name;
            this.f_api_data.details.account_number=this.select_act_item.account_number;
            this.f_api_data.details.beneficiary_name=this.select_act_item.beneficiary_name;
            this.f_api_data.details.swift_code=this.select_act_item.swift_code;
            this.f_api_data.details.address=this.select_act_item.address;

            this.f_api_data.details.intermediary_name=this.select_act_item.intermediary_name;
            this.f_api_data.details.intermediary_country=this.select_act_item.intermediary_country;
            this.f_api_data.details.intermediary_swift_code=this.select_act_item.intermediary_swift_code;
            this.f_api_data.details.intermediary_address=this.select_act_item.intermediary_address;

            // console.log(this.f_api_data);
            // console.log(this.select_act_item);
            // next

            if (this.f_api_data.details.intermediary_address==this.select_act_item.intermediary_address) {
                sessionStorage.setItem("fb_bz_1",JSON.stringify(this.f_api_data));
                this.$router.push('/blockchain_w/new_fiat2');
            }
            
        },
        xingx_fun(){
            this.xingx=!this.xingx;
        },
        add_form_btn2(){

        }

    }
}
</script>

<style scoped>
.step1{
    max-width: 521px;
    margin:10px auto 40px;
    /* background: pink; */
    display: flex;
    justify-content: space-between;
    text-align: center;
}
.s_img_box{
    position: relative;
    display: inline-block;
}
.s_img1{
    width: 44px;
}
.div1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    margin-top: 12px;
    color: #00C18E;
}
.s_img2{
    width: 135px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -151px;
}
/* 表格 */
.list_title1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.list_table{
    display: block;
    width: 100%;
}
.list_table>div{
    width: 100%;
    /* display: block; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.list_table>div:nth-child(odd){
    background: #2B323E;
    border-radius: 12px;
}
.list_table>div>div{
    /* min-width: 130px; */
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    box-sizing: border-box;
    padding: 20px 28px;
}
.list_table div .td1{
    width: 25%;
}
.list_table div .td2{
    width: 25%;
    word-wrap: break-word;
}
.list_table div .td3{
    width: 25%;
}
.list_table div .td4{
    width: 25%;
}
.list_table .text_r{
    text-align: right;
}
.list_table .el-checkbox{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.list_table >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#00C18E;
    border-color:#00C18E;
    box-shadow: 0px 0px 0px 2px #39526F inset;
}
.list_table >>> .el-checkbox__inner{
    border-radius: 50%;
    background: transparent;
    width: 24px;
    height: 24px;
}
.list_table >>> .el-checkbox__inner::after{
    display: none;
}
.zdy_table_list{
    background: #232A36;
    border-radius: 16px;
}
.table_btm{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #191E29;
}
.table_btm2{
    box-sizing: border-box;
    padding: 28px;
}
.table_btm_t1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.add_btn,
.add_btn:hover,
.add_btn:focus,
.add_btn:active{
    min-width: 300px;
    height: 44px;
    color: #BBBBBB;
    background: transparent;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    border-style:solid;
    border-width: 1.5px;
    border-color:#BBBBBB;
}
.sand_img{
    width: 20px;
    cursor: pointer;
    vertical-align: middle;
}
.edit_btn{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #FFFFFF;
    margin-bottom: 10px;
    cursor: pointer;
}
.delete_btn{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #F35F65;
    cursor: pointer;
}
/* ---- */
.shuxian{
    width: 3px;
    margin: 20px 28px;
}
.d_row{
    display: flex;
    justify-content: space-between;
}
.d_row>div{
    width: 48%;
}
.table_btm3{
    padding-bottom: 6px;
}
.sc_ntb{
    min-width: 260px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #00C18E;
    cursor: pointer;
    border-style:solid;
    border-width: 1.5px;
    border-color:#00C18E;
}
.width_auto{
    width: auto;
}
.xingx_img{
    width: 18px;
    margin-right: 13px;
    vertical-align: middle;
}
.inp_btm_txt{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 8px;
}
.continue_btn{
    cursor: pointer;
    background: #00C18E;
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #191E29;
    min-width: 224px;
    height: 38px;
    text-align: center;
    line-height: 38px;
}
.no_data_text{
    text-align: center;
    display: inherit;
}
</style>

<style>
.operate_pop{
    min-width: 100px !important;
    background: #223C58;
    border-radius: 8px;
    border: none;
}
.operate_pop .popper__arrow{
    display: none;
}
</style>